import React from 'react';
import { toast } from 'react-toastify';
import ButtonComponent from '../../../common/button-component/button-component';
import styles from './addToCartButton.module.css';
import useIsMobile from '../../../../hooks/useIsMobile';

interface Props {
  isCartEnabled: boolean;
  setIsCartEnabled: (isCartEnabled: boolean) => void;
  currentQuantity: number;
  maxQuantity: number;
  setCurrentQuantity: (currentQuantity: number) => void;
}

export default function AddToCartButton({
  isCartEnabled,
  setIsCartEnabled,
  currentQuantity,
  maxQuantity,
  setCurrentQuantity,
}: Props) {
  const isMobile = useIsMobile();
  const handleQuantityChange = (quantity: number) => {
    if (quantity > maxQuantity) {
      toast.error('Max selection limit reached!');
      return;
    }

    if (quantity < 1) {
      setIsCartEnabled(false);
      setCurrentQuantity(0);
      return;
    }

    setCurrentQuantity(quantity);
  };

  return isCartEnabled ? (
    <div className={styles.quantityContainer}>
      <div
        role="button"
        className={styles.quantityChangeButton}
        onClick={() => handleQuantityChange(currentQuantity - 1)}
        tabIndex={0}
      >
        {' '}
        -{' '}
      </div>
      <div role="button" className={styles.activeQuantity} tabIndex={0}>
        {currentQuantity}
      </div>
      <div
        role="button"
        className={styles.quantityChangeButton}
        onClick={() => handleQuantityChange(currentQuantity + 1)}
        tabIndex={0}
      >
        {' '}
        +{' '}
      </div>
    </div>
  ) : (
    <ButtonComponent
      fullWidth
      className={styles.addToCartButton}
      variant="primaryOutline"
      onClick={() => {
        setCurrentQuantity(1);
        setIsCartEnabled(!isCartEnabled);
      }}
    >
      <span className="text-sm">Add{!isMobile ? ' to Cart' : ''}</span>
    </ButtonComponent>
  );
}
